import axios from 'axios';
import React from 'react';
import { alertRef } from '../../../App';
import Modal from '../../../Components/Modal/Modal';
import { Button, Textarea } from '../../../Components/StyledComponents';
import './Intro.scss';

const Intro = () => {
    const [ intro, setIntro ] = React.useState('');//매장안내
    const [ tempIntro, setTempIntro ] = React.useState('');//매장안내 임시저장
    const [ isIntroModify, setIsIntroModify] = React.useState(false)//매장안내 수정여부
    const [ origin, setOrigin ] = React.useState('');//원산지
    const [ tempOrigin, setTempOrigin ] = React.useState('');//원산지 임시저장
    const [ isOriginModify, setIsOriginModify] = React.useState(false)//원산지 수정여부

    React.useEffect(() => {
        getOrigin()
    },[])

    //원산지 정보 get
    const getOrigin = () => {
        axios.get('/api/order/origin')
        .then((data) => {
            if(typeof data.data.OrderInfo.Origin === 'undefined') setOrigin('')
            else setOrigin(data.data.OrderInfo.Origin)
            getIntro()
        })
    }


    //매장 안내 정보 get
    const getIntro = () => {
        axios.get('/api/order/intro')
        .then((data) => {
            if(typeof data.data.OrderInfo.Intro === 'undefined') setIntro('')
            else setIntro(data.data.OrderInfo.Intro)
        })
    }

    //원산지 정보 수정
    const patchOrigin = () => {
        axios.patch('/api/order/origin',{
            Origin : origin
        })
        .then((data) => {
            if(data.status === 204){
                setIsOriginModify(false)
                alertRef.current.showAlert({ title : `원산지가 수정 되었어요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            setIsOriginModify(true)
            alertRef.current.showAlert({ title : `입력 항목을 확인해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //매장 안내 정보 수정
    const patchIntro = () => {
        axios.patch('/api/order/intro',{
            Intro : intro
        })
        .then((data) => {
            if(data.status === 204){
                setIsIntroModify(false)
                alertRef.current.showAlert({ title : `매장안내 수정 되었어요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            setIsIntroModify(true)
            alertRef.current.showAlert({ title : `입력 항목을 확인해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //매장안내 수정 여부 toggle
    const toggleIntro = () => {
        if( isIntroModify){
            setIntro(tempIntro)
        }else {
            setTempIntro(intro)
        }
        setIsIntroModify(old => !old)
    }

    //원산지 수정 여부 toggle
    const toggleOrigin = () => {
        if( isOriginModify){
            setOrigin(tempOrigin)
        }else {
            setTempOrigin(origin)
        }
        setIsOriginModify(old => !old)
    }

    return (
        <div className='intro'>
            <div className='info-box'>
                <div className='row between'>
                    <div>
                        <p className='info-box-title'>매장안내</p>
                        <p className='info-sub-title'>매장에 대한 안내사항이나 소개를 적어주세요.</p>
                    </div>
                    <div className='row'>
                        <Button variant='sub' small style={{ width : 88 }} onClick={() => toggleIntro()}>
                            { isIntroModify ? '취소하기' : '수정하기'}
                        </Button>
                        {
                            isIntroModify && 
                            <Button variant='main' small style={{ width : 88, marginLeft : 8 }} onClick={() => {setIsIntroModify(old => !old); patchIntro();}}>
                                저장하기
                            </Button>
                        }
                    </div>
                </div>

                <div className='header-divider' ></div>

                <Textarea
                    disabled={!isIntroModify}
                    value={intro}
                    onChange={(e) => setIntro(e.target.value)} 
                    style={{ width : '100%', height : 224 }}
                    placeholder='예) 안녕하세요. OO곱창입니다.'
                />
            </div>

            <div className='info-box'>
                <div className='row between'>
                    <div>
                        <p className='info-box-title'>원산지 안내</p>
                        <p className='info-sub-title'>매장의 음식에 대한 원산지를 적어주세요.</p>
                    </div>
                    <div className='row'>
                        <Button variant='sub' small style={{ width : 88 }} onClick={() => toggleOrigin()}>
                            { isOriginModify ? '취소하기' : '수정하기'}
                        </Button>
                        {
                            isOriginModify && 
                            <Button variant='main' small style={{ width : 88, marginLeft : 8 }} onClick={() => {patchOrigin();}}>
                                저장하기
                            </Button>
                        }
                    </div>
                </div>

                <div className='header-divider' ></div>

                <Textarea
                    disabled={!isOriginModify}
                    value={origin}
                    onChange={(e) => setOrigin(e.target.value)} 
                    style={{ width : '100%', height : 224, padding:16 }}
                    placeholder='예) 닭고기(국내산) / 우유(국내산) / 김치(국내산) / 닭고기(멕시코산)'
                />

                {
                    isOriginModify &&
                    <div style={{ marginTop : 24 }}>
                        <div className='row'>
                            <div className='warn-box'>
                                유의사항
                            </div>
                            <p className='warn-text'>원산지를 작성하기 전에 꼭 읽어주세요!</p>
                        </div>
                        <p style={{ whiteSpace : 'break-spaces', marginTop : 8}} className='origin-warn'>
                            {`∙ 원산지 정보는 줄바꿈 없이 한 줄로 작성해 주세요.
∙ 음식명 옆에 표시대상 원료인 농수산물과 그 원산지를 표시해 주세요. 예) 후라이드치킨(닭고기 : 멕시코산)
  예시1) 국내산(국산)의 섞음 비율이 외국산보다 높은 경우
  - 불고기피자(쇠고기 : 호주산, 돼지고기 : 국내산과 미국산 섞음)
  예시2) 국내산(국산)의 섞음 비율이 외국산보다 낮은 경우
  - 불고기피자(쇠고기 : 호주산, 돼지고기 : 미국산과 국내산 섞음)
∙ 원산지가 다른 식자재를 사용했을 경우 섞음 비율이 높은 순서대로 표시해 주세요.
∙ 표시대상 농수산물이나 그 가공품을 조리하여 배달을 통해 판매·제공하는 경우에는 해당 농수산물 또는 가공품의 원료의 원산지를 포장재에 표시하여야 합니다. (단 포장재에 표시하기 어려운 경우에는 전단지, 스티커 또는 영수증 등에 표시하여야 합니다.)
∙ 원산지 표시는 농림축산식품부가 고지한 「농산물의 원산지 표시에 관한 법률」에 의한 필수 표시사항입니다. 원산지를 표시하지 않거나 거짓으로 표시할 경우 「농수산물의 원산지 표시에 관한 법률」에 따라 처벌될 수 있습니다. 누락이나 오표시로 인한 광고 서비스 제한 또는 법적 책임 등의 불이익을 받지 않으시길 바랍니다.
∙ 음식명 옆에 표시대상 원료인 농수산물과 그 원산지를 표시해 주세요. 예) 후라이드치킨(닭고기 : 멕시코산)`}
                            </p>
                    </div>
                }
            </div>
        </div>
    )
}

export default Intro;